import { runOnceCookieIsAllowed } from "@soenergy/frontend-library/src/services/CookiePreferences"
import Mixpanel from "@soenergy/frontend-library/src/services/Mixpanel"
import { getStore } from "@/plugins/store"

export const mixpanelProperties = {
  fuel: "Quote - Fuel Type",
  meterType: "Quote - Meter Type",
  isMeterMultirate: "Quote - Multirate Meter",
  estimatedUsage: "Quote - Estimated Usage",
  exactAmountGas: "Quote - Exact Usage Amount Gas",
  exactAmountElec: "Quote - Exact Usage Amount Elec",
  seasonalPayments: "Quote - Seasonal Payments",
  priorityServiceRegister: "Quote - PSR",
  marketingOptIn: "Quote - Marketing Opt-in"
}

export default {
  registerInputs() {
    runOnceCookieIsAllowed("performance", () => {
      const inputs = getStore().state.quote.form

      const missingProp = Object.keys(mixpanelProperties).find(
        prop => !(prop in inputs)
      )
      if (missingProp) {
        throw new Error(`'Mixpanel prop is missing (${missingProp})`)
      }
      const inputsMappedToMixpanelNames = Object.entries(inputs).reduce(
        (allProps, [key, value]) => {
          const mixpanelName = mixpanelProperties[key]

          const isPropNotTracked = !mixpanelName
          const isPropEmpty =
            value === undefined || value === null || value?.usage === null // special handing for usage objects

          if (isPropNotTracked || isPropEmpty) return allProps

          allProps[mixpanelName] = value
          return allProps
        },
        {}
      )
      Mixpanel.register(inputsMappedToMixpanelNames)
    })
  },
  unregisterTrackedInputs() {
    Object.values(mixpanelProperties).forEach(name => Mixpanel.unregister(name))
  },
  trackStart(variant, experimentName) {
    runOnceCookieIsAllowed("performance", () => {
      const abTestProps = {
        "Experiment name": experimentName,
        "Variant name": variant
      }
      Mixpanel.register(abTestProps)
      Mixpanel.sendEvent(`$experiment_started`, abTestProps)
      Mixpanel.sendEvent(`Quote and Switch - AB test started`)
    })
  },
  trackSuccess({ isEmailInUse }) {
    const { selectedQuote, form } = getStore().state.quote
    const quoteDetails = {
      "Tariff Name": selectedQuote.tariffName,
      "Tariff Length": String(selectedQuote.durationMonths),
      "Payment Plan": form.seasonalPayments ? "Seasonal" : "Equal",
      "Email In Use": isEmailInUse
    }
    runOnceCookieIsAllowed("performance", () => {
      Mixpanel.sendEvent(`Quote and Switch - completed`, quoteDetails)
    })
  },
  trackError() {
    runOnceCookieIsAllowed("performance", () => {
      Mixpanel.sendEvent(`Quote and Switch - unsuccessful`)
    })
  }
}
